import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { Dispatch } from 'redux'
import { TradeListItem } from 'app/models/trade-list-params'
import { coalesceThunk } from 'app/state/utils/coalesce-thunk'
import { ErrorNotification } from 'app/views/components/notifications/notification'
import {
  getTradeList,
  startLoadingTradeList,
  stopLoadingTradeList,
} from './actions'

/**
 * ONE request for the whole Trade List screen: GET /api/trade-list returns the
 * rows already joined and folded, so the page no longer loads master trades,
 * sub trades, traded facilities, facilities, deals and entities to stitch them
 * itself. On failure the store keeps what it had, the loader stops, and the
 * user is told, since this one request is the screen's only source.
 */
export const loadTradeList = coalesceThunk(
  () => async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    try {
      dispatch(startLoadingTradeList())
      const response = await client.get(`${apiServerUrl}/api/trade-list`)
      return dispatch(getTradeList(response.data as TradeListItem[]))
    } catch {
      // The store keeps what it had and the loader stops; the API client's
      // interceptors already log the request. Unlike the old page's many
      // list loads, this is the screen's ONLY source, so a silent failure
      // would read as "no trades" (or pass stale rows off as current):
      // say so instead.
      ErrorNotification({
        title: "Couldn't load the Trade List",
        message: 'The list may be empty or out of date. Refresh the page to try again.',
      })
    } finally {
      dispatch(stopLoadingTradeList())
    }
  },
)
